import { LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';

@customElement('nile-rte-preview')
export class NileRtePreview extends LitElement {
  protected createRenderRoot() { return this; }
  protected shouldUpdate() { return false; }
}
declare global { interface HTMLElementTagNameMap { 'nile-rte-preview': NileRtePreview; } }
